import * as React from "react";
import {useEffect, useMemo, useRef, useState} from "react";
import {RouteComponentProps} from "react-router";
import {SLIDE} from "../../../views/bo-core/Accordeon";
import {getAllDataViewsByBOId, getBoTypeAll, graphQlRequest} from "../../../actions/boCoreActions";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import Utils from "../../../Utils";
import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";
import {connect} from "react-redux";
import * as gql from 'gql-query-builder'
import _ from "lodash";
import toastr from "toastr";
import LoadinModal from "../modals/LoadinModal";
import InstanceLayoutBreadcrumb from "./breadcrumbComponent/InstanceLayoutBreadcrumb";
import './instanceLayoutEditor.css'
import getAttributesEditor from "../common/AgInstanceAttributes";
import LookupInstanceModal from "../modals/LookupInstanceModal";
import EditAttrModal from "./editAttrModal/EditAttrModal";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface Props extends RouteComponentProps {
    slide: SLIDE,
    businessObject: any;
    backToList(boName: string): void;
}

export enum GRID_TYPE {
    ATTRIBUTES_GRID = 'ATTRIBUTES_GRID',
    RELATIONSHIPS_GRID = 'RELATIONSHIPS_GRID',
    RELATIONSHIPS_ATTRIBUTES_GRID = 'RELATIONSHIPS_ATTRIBUTES_GRID',
    RELATED_RECORDS_GRID = 'RELATED_RECORDS_GRID',
    RELATED_RECORD_ATTRIBUTES_GRID = 'RELATED_RECORD_ATTRIBUTES_GRID'
}

let scrollTop = 0;
let pending = false;
let lazyLoadedInstance = null;
let selectedRelationTypeNodeForLazy = null;
let relationObj = null;
let doubleClickedRel = null;
let dataObject = null;
let relatedRecordsGridApi = null;
let relationshipAttrGridApi = null;
let relationshipAttrColumnApi = null;
let relatedInstanceAttrGridApi = null;
let relatedInstanceAttrColumnApi = null;
let attributesGridApi = null;
const LIMIT = 30
const overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading...</span>'

const InstanceLayoutEditor = (props: Props) => {
    const [mounted, setMounted] = useState(false);

    //Instance attributes grid
    const [attrColumnDefs, setAttrColumnDefs] = useState([]);
    const [rowDataAttributes, setRowDataAttributes] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [columnApiAttr, setColumnApiAttr] = useState(null);

    //Instance relationships grid
    const [columnDefsRelationsGrid, setColumnDefsRelationsGrid] = useState([]);
    const [rowDataRelations, setRowDataRelations] = useState([]);
    const [gridApiRelations, setGridApiRelations] = useState(null);

    //Selected relationship's attributes grid
    const [columnDefsRelationTypeAttrGrid, setColumnDefsRelationTypeAttrGrid] = useState([]);
    const [rowDataRelationTypeAttr, setRowDataRelationTypeAttr] = useState([]);
    const [gridApiRelationTypeAttr, setGridApiRelationTypeAttr] = useState(null);
    const [columnApiRelationTypeAttr, setColumnApiRelationTypeAttr] = useState(null);

    //Related records grid
    const [columnDefsRelatedRecGrid, setColumnDefsRelatedRecGrid] = useState([]);
    const [rowDataRelatedRec, setRowDataRelatedRec] = useState([]);
    const [gridApiRelatedRec, setGridApiRelatedRec] = useState(null);

    //Selected related record's attributes grid
    const [columnDefsRelationsAttrGrid, setColumnDefsRelationsAttrGrid] = useState([]);
    const [rowDataRelationsAttr, setRowDataRelationsAttr] = useState([]);
    const [gridApiRelationsAttr, setGridApiRelationsAttr] = useState(null);
    const [columnApiRelationsAttr, setColumnApiRelationsAttr] = useState(null);
    const [selectedRelatedRecordName, setSelectedRelatedRecordName] = useState<string>('');

    const [instance, _setInstance] = useState<any>(null);
    const instanceRef = React.useRef(instance);
    const [loading, setLoading] = useState<any>(false);
    const [selectedRelation, setSelectedRelation] = useState<number>(-1);
    const [breadcrumbSteps, setBreadcrumbSteps] = useState<any>([]);
    const [attrValue, setAttrValue] = useState<any>({});
    const [textAreaValueHandler, setTextAreaValueHandler] = useState<any>(null);
    const [selectedRelationTypeNode, setSelectedRelationTypeNode] = useState<any>(null);
    const [selectedRelatedRecordId, setSelectedRelatedRecordId] = useState<number>(-1);

    const lookupInstanceModal = useRef(null);
    let textAreaModalRef = useRef(null);
    const loadedDataViews = useRef([]);

    const setInstance = inst => {
        instanceRef.current = inst;
        _setInstance(inst);
    };

    useEffect(() => {
        // componentWillUnmount
        return () => {
            Utils.$("#hide-nav-btn").off();
            resetState();
        }
    }, [])

    useEffect(() => {
        if (props.slide === SLIDE.LAYOUT_EDITOR) {
            if (props.match.params['id'] !== "-1") {
                resetState();
                setSelectedRelationTypeNode(null);
                getGridData(props.businessObject.id);
                setMounted(true);
            }
        } else if (props.slide === SLIDE.GRID_EDITOR && mounted) {
            resetState();
            setSelectedRelationTypeNode(null);
            setBreadcrumbSteps([]);
        }
    }, [props.match.params['id'], props.slide]);

    useEffect(() => {
        if (gridApiRelationsAttr && gridApiRelatedRec) {
            setTimeout(() => {
                gridApiRelatedRec.forEachNode(node => {
                    if (node.rowIndex === 0) {
                        node.setSelected(true);
                        setSelectedRelatedRecordId(node.data.id);
                    }
                })
            },100)
        }
    },[rowDataRelatedRec])

    useEffect(() => {
        if (gridApiRelationsAttr && gridApiRelatedRec) {
            setTimeout(() => {
                gridApiRelations.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))
                gridApiRelatedRec.forEachNode(node => {
                    if (node.rowIndex === 0) {
                        node.setSelected(true);
                        setSelectedRelatedRecordId(node.data.id);
                    }
                })
            },100)
        }
    },[rowDataRelations])

    useEffect(() => {
        if (breadcrumbSteps.length > 0) {
            getGridData(breadcrumbSteps[breadcrumbSteps.length - 1].boId, breadcrumbSteps[breadcrumbSteps.length - 1].instanceId)
        }
    }, breadcrumbSteps.length)

    useEffect(() => {
        if (selectedRelationTypeNode) {
            getRelationshipTypeValues();
        }
    }, [selectedRelationTypeNode && selectedRelationTypeNode.data.relKey])

    useEffect(() => {
        if (selectedRelationTypeNode) {
            setTimeout(() => {
                selectedRelationTypeNode.node.setSelected(true);
            },100)
        }
    }, [selectedRelationTypeNode, rowDataRelations])

    useEffect(() => {
        if (instance) {
            Object.keys(GRID_TYPE).forEach(type => {
                buildGrid(instance, type);
            })
        }
    }, [instance])

    useEffect(() => {
        sizeAllColumnsToFit();
    }, [rowDataRelations, rowDataRelatedRec, rowDataRelationTypeAttr, rowDataRelationsAttr, rowDataAttributes])

    useEffect(() => {
        relatedRecordsGridApi = gridApiRelatedRec;
    }, [gridApiRelatedRec])

    const getGridData = (boClassId: number, instanceId?: number) => {
        setLoading(true);
        if (instance) {
            getBoObjectData(instance.boTypes, boClassId, instanceId)
        } else {
            getBoTypeAll()
                .then((response) => {
                    getBoObjectData(response.data, boClassId, instanceId)
                })
                .catch(() => {
                    setLoading(false);
                })
        }
    }

    const generateGridData = (foundBoObject, currentInstanceId, boTypes, firstRender, queryObject, lazyLoaded, resolve, reject) => {
        //building fresh data
        const gridData = {
            boClass: {
                name: foundBoObject.name,
                boKey: foundBoObject.boKey,
                id: foundBoObject.id
            },
            instance: {
                name: '',
                id: currentInstanceId
            },
            attributes: foundBoObject.attributes,
            relationships: foundBoObject.relationships,
            query: {},
            boTypes: boTypes
        };
        const qryFields = {records: []}
        qryFields.records.push(getRelatedBoClassInfo(foundBoObject.id, boTypes).objProps.toString());
        // get the attributes of the relationships and the attributes of the record type
        gridData.relationships.forEach(rel => {
            const relatedClassId = foundBoObject.id === rel.toBoClassId ? rel.fromBoClassId : rel.toBoClassId;
            const toBoClassInfo = getRelatedBoClassInfo(relatedClassId, boTypes);
            // if outward is true, show outward in the grid and in the breadcrumb
            toBoClassInfo['outward'] = relatedClassId === rel.fromBoClassId;
            rel['toBoClassInfo'] = toBoClassInfo;
            rel['values'] = [];

            if (firstRender) {
                queryObject.page.relations[rel.relKey] = {
                    limit: 0,
                    offset: 0
                };
                if (rel.fromBoClassId === rel.toBoClassId) {
                    queryObject.page.relations[rel.reverseRelKey] = {
                        limit: 0,
                        offset: 0
                    };
                }
            }

            const createRec = (key: string) => {
                const rec = {
                    [key]: [
                        'relationsCount',
                        {
                            relations: [
                                {
                                    record: toBoClassInfo.objProps
                                }
                            ]
                        },
                    ]
                };
                if (rel.attributes && rel.attributes.length > 0) {
                    rec[key][1]['relations'].push(rel.attributes.map(attr => attr.attrKey).join(','))
                }
                return rec;
            }

            if (rel.fromBoClassId === rel.toBoClassId) {
                qryFields.records.push(createRec(rel.relKey), createRec(rel.reverseRelKey));
            } else {
                qryFields.records.push(createRec(rel.relKey));
            }
        })
        const json = JSON.stringify(queryObject.page);
        const unquoted = json.replace(/"([^"]+)":/g, '$1:');
        gridData.query = queryObject;
        gridData['firstRender'] = firstRender;

        const query = gql.query({
            operation: `${foundBoObject.boKey}(qry: "id==${currentInstanceId}", page: ${unquoted})`,
            fields: [qryFields]
        })
        makeGraphQlRequest(query, gridData, lazyLoaded).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    }

    const orderAttributes = (foundBoObject, foundDataView) => {
        return foundBoObject.attributes.map(attr => {
            const foundCol = foundDataView.columns.find(col => col.type === 'attribute' &&
                col.value.id === attr.id);
            if (foundCol) {
                return {
                    ...attr,
                    columnOrder: foundCol.columnOrder
                }
            } else {
                return attr;
            }
        }).sort((a,b) => (a.columnOrder > b.columnOrder) ? 1 : ((b.columnOrder > a.columnOrder) ? -1 : 0));
    }

    /**
     * Summary:
     * The method creates the metadata which is necessary for the graphQL API.
     * Use only if you need to fetch new data for the page
     */
    const getBoObjectData = (boTypes: any, boClassId: number, instanceId?: number, query?: any, lazyLoaded?: boolean) =>
        new Promise((resolve, reject) => {
        const foundBoObject = boTypes.find(obj => boClassId === obj.id);
        const currentInstanceId = instanceId ? instanceId : parseInt(props.match.params['id']);
        let queryObject;
        let firstRender = true;
        if (query) {
            queryObject = _.cloneDeep(query);
            firstRender = Object.keys(queryObject.page.relations).length === 0;
        } else {
            queryObject = {
                page: {
                    relations: {}
                }
            }
        }
        if (foundBoObject) {
            const foundDataView = loadedDataViews.current.find(view => view.businessObjectClass.id === foundBoObject.id);
            if (!foundDataView) {
                getAllDataViewsByBOId(foundBoObject.id)
                    .then(dataViewResponse => {
                        const fullView = dataViewResponse.data.find(el => el.viewName === "full");
                        if (fullView) {
                            loadedDataViews.current.push(fullView);
                            foundBoObject.attributes = orderAttributes(foundBoObject, fullView);
                        }
                    })
                    .catch(error => {
                        toastr.error(error.response.data.message);
                    })
                    .finally(() => {
                        generateGridData(foundBoObject, currentInstanceId, boTypes, firstRender, queryObject, lazyLoaded, resolve, reject);
                    })
            } else {
                foundBoObject.attributes = orderAttributes(foundBoObject, foundDataView);
                generateGridData(foundBoObject, currentInstanceId, boTypes, firstRender, queryObject, lazyLoaded, resolve, reject);
            }
        }
    })

    const makeGraphQlRequest = (query: any, gridData?: any, lazyLoaded?: boolean) => new Promise((resolve, reject) => {
        graphQlRequest(query)
            .then((response) => {
                setLoading(false);
                if (Object.keys(response.data).includes('errors')) {
                    if (response.data.errors.length > 0) {
                        toastr.error(response.data.errors.map(item => item.message).join('\n'));
                    }
                    reject();
                } else {
                    if (gridData)
                        handleGraphQLResponse(response.data.data, gridData, lazyLoaded);
                    resolve(response);
                }
            })
            .catch(error => {
                setLoading(false);
                reject(error);
            })
    })

    /**
     * Summary:
     * The method maps the response data from the graphQL api to the provided metadata
     * and builds an object which contains all the needed information for the page.
     */
    const handleGraphQLResponse = (response, gridData, lazyLoaded?) => {
        const responseObj = response[gridData.boClass.boKey].records[0];
        Object.keys(responseObj).forEach(key => {
            const foundAttr = gridData.attributes.find(attr => attr.attrKey === key);
            const foundRelType = gridData.relationships.find(rel => {
                if (rel.fromBoClassId === rel.toBoClassId) {
                    return rel.relKey === key || rel.reverseRelKey === key
                } else {
                    return rel.relKey === key
                }
            });
            if (foundAttr) {
                foundAttr['value'] = responseObj[key];
            }

            if (foundRelType) {
                if (Array.isArray(responseObj[key].relations)) {
                    responseObj[key].relations.forEach(record => {
                        const relObj = {
                            relAttributes: [],
                            relatedInstance: {
                                name: '',
                                id: -1,
                                attributes: []
                            }
                        }

                        Object.keys(record).forEach(prop => {
                            // record = related instance
                            if (prop !== 'record'){
                                let relAttr = foundRelType.attributes.find(attr => attr.attrKey === prop);
                                if (relAttr) {
                                    relAttr['value'] = record[prop];
                                    relObj.relAttributes.push(relAttr);
                                }
                            } else {
                                Object.keys(record[prop]).forEach(instanceAttr => {
                                    let attribute = foundRelType.toBoClassInfo.attrFull.find(attr => attr.attrKey === instanceAttr);
                                    if (instanceAttr === 'id') {
                                        relObj.relatedInstance.id = record[prop][instanceAttr];
                                    } else {
                                        if (attribute) {
                                            const attrCopy = _.cloneDeep(attribute);
                                            attrCopy['value'] = record[prop][instanceAttr];
                                            if (instanceAttr === 'name') {
                                                relObj.relatedInstance.name = record[prop][instanceAttr];
                                            }
                                            relObj.relatedInstance.attributes.push(attrCopy);
                                        }
                                    }
                                })
                            }
                        })
                        foundRelType.values.push(_.cloneDeep(relObj));
                    })
                    if (foundRelType.fromBoClassId === foundRelType.toBoClassId) {
                        foundRelType[`${key}NumOfRelatedValues`] = responseObj[key].relationsCount;
                    } else {
                        foundRelType['numOfRelatedValues'] = responseObj[key].relationsCount;
                    }
                }
            }
        })

        gridData.instance.name = responseObj.name;
        gridData.relationships.sort((a, b) => {
            return a.toBoClassInfo.name > b.toBoClassInfo.name ? 1 : b.toBoClassInfo.name > a.toBoClassInfo.name ? -1 : 0;
        });

        // load the related records of the first relationship
        if (gridData.firstRender) {
            relationObj = gridData.relationships[0];
            // In the case when the related items are from the same type and the relationship is outward the key is set this way
            // because at GRID_TYPE.RELS_GRID we are adding the reverseRelKey as relKey to the first pushed instance and then
            // we are adding the relKey as relKey to the second pushed instance
            const key = relationObj.fromBoClassId === relationObj.toBoClassId ?
                (relationObj.toBoClassInfo.outward ? relationObj.reverseRelKey : relationObj.relKey) : relationObj.relKey;
            const query = Utils.deep_copy(gridData.query);
            query.page.relations[key].limit = LIMIT;
            query.page.relations[key].offset = 0;
            getBoObjectData(gridData.boTypes, gridData.boClass.id, gridData.instance.id, query)
        }

        if (lazyLoaded) {
            const relIndex = gridData.relationships.findIndex(rel => {
                if (rel.fromBoClassId === rel.toBoClassId) {
                    return rel.relKey === selectedRelationTypeNodeForLazy.data.relKey ||
                        rel.reverseRelKey === selectedRelationTypeNodeForLazy.data.relKey
                } else {
                    return rel.relKey === selectedRelationTypeNodeForLazy.data.relKey
                }
            });
            gridData.relationships[relIndex].values = lazyLoadedInstance.relationships[relIndex].values.concat(gridData.relationships[relIndex].values)
        } else {
            breadcrumbHandler(gridData);
        }

        setInstance(gridData);
        dataObject = gridData;
        lazyLoadedInstance = JSON.parse(JSON.stringify(gridData));
        setTimeout(() => {
            if (document.activeElement) {
                Utils.$(document.activeElement).blur();
            }
            Utils.$('#input-instance-name').focus();
        },500)
    }

    const sizeAllColumnsToFit = () => {
        if (gridApiRelationsAttr && gridApiRelatedRec && gridApiRelations && gridApiRelationTypeAttr && gridApi ) {
            gridApiRelationsAttr.sizeColumnsToFit();
            gridApiRelatedRec.sizeColumnsToFit();
            gridApiRelations.sizeColumnsToFit();
            gridApiRelationTypeAttr.sizeColumnsToFit();
            gridApi.sizeColumnsToFit();
        }
    }

    /**
     * Summary:
     * The method adds the selected instance data
     */
    const breadcrumbHandler = (dataObject: any) => {
        let breadcrumb = _.cloneDeep(breadcrumbSteps);
        const selectedCrumb = {
            boName: dataObject.boClass.name,
            boId: dataObject.boClass.id,
            instanceName: dataObject.instance.name,
            instanceId: dataObject.instance.id,
            relationships: dataObject.relationships,
            relation: doubleClickedRel
        }

        const index = _.findIndex(breadcrumb, function (item) {
            return item.instanceId === selectedCrumb.instanceId
        });

        if (index === -1) {
            breadcrumb.push(selectedCrumb)
            setBreadcrumbSteps(breadcrumb);
        }
    }

    /**
     * Summary:
     * The method updates the select breadcrumb step data
     */
    const updateBreadcrumbStep = (dataObject: any) => {
        let breadcrumb = _.cloneDeep(breadcrumbSteps);
        const selectedCrumb = {
            boName: dataObject.boClass.name,
            boId: dataObject.boClass.id,
            instanceName: dataObject.instance.name,
            instanceId: dataObject.instance.id,
            relationships: dataObject.relationships,
            relation: relationObj
        }
        const index = _.findIndex(breadcrumb, function (item) {
            return item.instanceId === selectedCrumb.instanceId
        });

        if (index !== -1) {
            breadcrumb[index] = selectedCrumb;
            setBreadcrumbSteps(breadcrumb);
        }
    }

    const getRelatedBoClassInfo = (toBoClassId: number, allBoTypes: any) => {
        const foundObj = allBoTypes.find(item => item.id === toBoClassId);
        if (foundObj) {
            const relatedObject = {
                attrFull: foundObj.attributes,
                name: foundObj.name,
                id: foundObj.id,
                boKey: foundObj.boKey,
                objProps: []
            };
            relatedObject.objProps = foundObj.attributes.map(attr => {
                if (attr.type.toLowerCase() === 'lookup') {
                    return `${attr.attrKey}{id value}`
                }
                return attr.attrKey;
            });

            relatedObject.objProps.push("id");
            return relatedObject;
        }
    }

    const resetState = () => {
        setInstance(null);
        setMounted(false);
        if (gridApiRelations && gridApiRelatedRec) {
            gridApiRelations.deselectAll();
            gridApiRelatedRec.deselectAll();
        }
        resetLazyLoadingProps();
    };

    const resetLazyLoadingProps = () => {
        scrollTop = 0;
        pending = false;
        lazyLoadedInstance = null;
        selectedRelationTypeNodeForLazy = null;
    }

    const buildGrid = (gridData, grid) => {
        let rowData = [];
        let columnDefs = [];
        switch (grid){
            case GRID_TYPE.ATTRIBUTES_GRID:
                rowData = getAttributes(gridData.attributes);
                columnDefs = [
                    {
                        id: "name",
                        headerName: "Attribute Name",
                        headerClass: 'name-column',
                        field: "name",
                        headerTooltip: "Attribute Name",
                        type: 'text',
                        width: 140,
                        suppressSizeToFit: true,
                    },
                    {
                        editable: true,
                        field: 'value',
                        colKey: 'value',
                        headerName: "Value",
                        headerClass: 'value-column',
                        tooltipField: 'Value',
                        headerTooltip: "Attribute Value",
                        cellEditorSelector: (item) => {
                            if (item.data.type === AttributeTypeEnum.BOOLEAN) {
                                const values = ['true', 'false'];
                                if (!item.data.required) {
                                    values.unshift('n/a');
                                }
                                return {
                                    component: 'agRichSelect',
                                    params: { values }
                                };
                            }
                            return { component: 'agInstanceAttributes' };
                        },
                        cellRenderer: attributesCellRenderer,
                        onCellValueChanged: params => updateInstanceAttrCellValue(params, GRID_TYPE.ATTRIBUTES_GRID),
                        boTypes: gridData.boTypes,
                        gridType: GRID_TYPE.ATTRIBUTES_GRID
                    },
                ];
                setAttrColumnDefs(columnDefs)
                setRowDataAttributes(rowData);
                break;
            case GRID_TYPE.RELATIONSHIPS_GRID:
                gridData.relationships.forEach((item, index) => {
                    if (selectedRelationTypeNode) {
                        if (index === selectedRelationTypeNode.rowIndex) {
                            setSelectedRelation(item.id);
                        }
                    } else {
                        if (index === 0) {
                            setSelectedRelation(item.id);
                            selectedRelationTypeNodeForLazy = {
                                data: {
                                    relKey: item.relKey,
                                    numOfRelatedValues: item.numOfRelatedValues
                                }
                            }
                        }
                    }

                    rowData.push({
                        relationship: item.toBoClassInfo.outward ? item.outward : item.inward,
                        fromRelName: item.toBoClassInfo.name,
                        boKey: item.toBoClassInfo.boKey,
                        numOfRelatedValues: item.fromBoClassId === item.toBoClassId ?
                            (item.toBoClassInfo.outward ? item[`${item.reverseRelKey}NumOfRelatedValues`] :
                                item[`${item.relKey}NumOfRelatedValues`])
                            : item.numOfRelatedValues,
                        id: item.id,
                        value: item.values,
                        relKey: item.fromBoClassId === item.toBoClassId ?
                            (item.toBoClassInfo.outward ? item.reverseRelKey : item.relKey) : item.relKey
                    });

                    if (item.fromBoClassId === item.toBoClassId) {
                        rowData.push({
                            relationship: item.toBoClassInfo.outward ? item.inward : item.outward,
                            fromRelName: item.toBoClassInfo.name,
                            boKey: item.toBoClassInfo.boKey,
                            numOfRelatedValues: item.fromBoClassId === item.toBoClassId ?
                                (item.toBoClassInfo.outward ? item[`${item.relKey}NumOfRelatedValues`] :
                                    item[`${item.reverseRelKey}NumOfRelatedValues`])
                                : item.numOfRelatedValues,
                            id: item.id,
                            value: item.values,
                            relKey: item.toBoClassInfo.outward ? item.relKey : item.reverseRelKey
                        });
                    }
                })

                columnDefs = [
                    {
                        id: "relationship",
                        headerName: "Relationship",
                        headerClass: 'name-column',
                        field: "relationship",
                        headerTooltip: "Relationship Name",
                        type: 'text',
                    },
                    {
                        field: 'fromRelName',
                        headerName: "Related Type",
                        tooltipField: 'fromRelName',
                        headerClass: 'name-column',
                        headerTooltip: "Related Type",
                    },
                    {
                        field: 'numOfRelatedValues',
                        headerName: "Records",
                        tooltipField: 'numOfRelatedValues',
                        headerTooltip: "Number of Related Records",
                        headerClass: 'value-column',
                        type: 'text'
                    }
                ];
                setColumnDefsRelationsGrid(columnDefs)
                if (gridData.firstRender) {
                    setRowDataRelations(rowData);
                }
                break;
            case GRID_TYPE.RELATED_RECORDS_GRID:
                if (selectedRelationTypeNode) {
                    const foundRelType = findRelationshipType(gridData, selectedRelationTypeNode.data.relKey)
                    if (foundRelType) {
                        rowData = foundRelType.values.map((item, index) => {
                            return {
                                relatedRecordName: item.relatedInstance.name,
                                id: item.relatedInstance.id
                            }
                        })
                    }
                } else {
                    if (gridData.relationships[0].values.length > 0) {
                        rowData = gridData.relationships[0].values.map((item, index) => {
                            return {
                                relatedRecordName: item.relatedInstance.name,
                                id: item.relatedInstance.id
                            }
                        })
                    }
                }

                columnDefs = [
                    {
                        id: "relatedRecordName",
                        headerName: "Related Record Name",
                        field: "relatedRecordName",
                        headerClass: 'name-column',
                        headerTooltip: "Related Record Name",
                        type: 'text',
                    },
                ];
                setColumnDefsRelatedRecGrid(columnDefs)
                setRowDataRelatedRec(rowData);
                break;
            case GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID:
                if (selectedRelationTypeNode) {
                    const foundRelType = findRelationshipType(gridData, selectedRelationTypeNode.data.relKey)
                    if (foundRelType) {
                        if (foundRelType.values.length > 0) {
                            rowData = getAttributes(foundRelType.values[0].relatedInstance.attributes);
                            setSelectedRelatedRecordName(foundRelType.values[0].relatedInstance.name);
                        } else {
                            setSelectedRelatedRecordName('');
                        }
                    } else {
                        setSelectedRelatedRecordName('');
                    }
                } else {
                    if (gridData.relationships[0].values.length > 0) {
                        if (gridData.relationships[0].values.length > 0) {
                            rowData = getAttributes(gridData.relationships[0].values[0].relatedInstance.attributes)
                            setSelectedRelatedRecordName(gridData.relationships[0].values[0].relatedInstance.name);
                        }
                    } else {
                        setSelectedRelatedRecordName('');
                    }
                }

                columnDefs = [
                    {
                        field: 'name',
                        headerName: "Attribute Name",
                        tooltipField: 'name',
                        headerTooltip: "Attribute Name",
                        headerClass: 'name-column',
                        // width: 50,
                        // suppressNavigable: true // -> this prop breaks the tab functionality very bad!
                    },
                    {
                        editable: true,
                        field: 'value',
                        colKey: 'value',
                        headerName: "Value",
                        tooltipField: 'value',
                        headerClass: 'value-column',
                        headerTooltip: "Attribute Value",
                        cellEditorSelector: (item) => {
                            if (item.data.type === AttributeTypeEnum.BOOLEAN) {
                                const values = ['true', 'false'];
                                if (!item.data.required) {
                                    values.unshift('n/a');
                                }
                                return {
                                    component: 'agRichSelect',
                                    params: { values }
                                };
                            }
                            return { component: 'agInstanceAttributes' };
                        },
                        onCellValueChanged: params => updateInstanceAttrCellValue(params, GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID),
                        cellRenderer: attributesCellRenderer,
                        boTypes: gridData.boTypes,
                        gridType: GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID
                    },
                ];
                setColumnDefsRelationsAttrGrid(columnDefs);
                setRowDataRelationsAttr(rowData);
                break;
            case GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID:
                if (selectedRelationTypeNode) {
                    const foundRelType = findRelationshipType(gridData, selectedRelationTypeNode.data.relKey)
                    if (foundRelType) {
                        if (foundRelType.values.length > 0) {
                            rowData = getAttributes(foundRelType.values[0].relAttributes);
                        }
                    }
                } else {
                    if (gridData.relationships[0].values.length > 0) {
                        rowData = getAttributes(gridData.relationships[0].values[0].relAttributes)
                    }
                }

                columnDefs = [
                    {
                        field: 'name',
                        headerName: "Attribute Name",
                        tooltipField: 'name',
                        headerTooltip: "Attribute Name",
                        headerClass: 'name-column',
                        // width: 50,
                        // suppressNavigable: true // -> this prop breaks the tab functionality very bad!
                    },
                    {
                        editable: true,
                        field: 'value',
                        colKey: 'value',
                        headerName: "Value",
                        tooltipField: 'value',
                        headerTooltip: "Attribute Value",
                        headerClass: 'value-column',
                        cellEditorSelector: (item) => {
                            if (item.data.type === AttributeTypeEnum.BOOLEAN) {
                                const values = ['true', 'false'];
                                if (!item.data.required) {
                                    values.unshift('n/a');
                                }
                                return {
                                    component: 'agRichSelect',
                                    params: { values }
                                };
                            }
                            return { component: 'agInstanceAttributes' };
                        },
                        onCellValueChanged: updateRelationshipAttrCellValue,
                        cellRenderer: attributesCellRenderer,
                        gridType: GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID
                    },
                ];
                setColumnDefsRelationTypeAttrGrid(columnDefs);
                setRowDataRelationTypeAttr(rowData);
                break;
            default:
                break;
        }
        Utils.$("#hide-nav-btn").on("click", function () {
            setTimeout(() => {
                sizeAllColumnsToFit()
            }, 500);
        });
    };

    const findRelationshipType = (data: any, relKey?: string, id?: number) => {
        if (relKey) {
            return data.relationships.find(rel => {
                if (rel.fromBoClassId === rel.toBoClassId) {
                    return rel.relKey === relKey || rel.reverseRelKey === relKey
                } else {
                    return rel.relKey === relKey
                }
            })
        }
        if (id) {
            return data.relationships.find(item => item.id === id);
        }
        return null;
    }

    const attributesCellRenderer = (params: any) => {
        if (!params.node.group) {
            if (params.data.type === AttributeTypeEnum.LOOKUP) {
                return `<span>${params.data.value.value || JSON.parse(params.data.value).value}</span>`;
            }
            if (params.data.type === AttributeTypeEnum.EMAIL) {
                return `<span>${Utils.parseEmailAttributeValue(params.value)}</span>`;
            }
            if (params.data.type === AttributeTypeEnum.TEXT || params.data.type === AttributeTypeEnum.JSON) {
                const eDiv = document.createElement('div');
                eDiv.innerHTML = `<span style="max-width: 70%; word-wrap: break-word; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${params.value}</span>
                            <span><button id="previewTxtBtn" style="float: right; background-color: transparent; border: transparent;">
                                <i class="fas fa-search fa-lg"></i></button></span>`;
                const eButton = eDiv.querySelectorAll('#previewTxtBtn')[0];
                eDiv.style.cssText = 'display: flex; white-space: initial; justify-content: space-between';

                eButton.addEventListener('click', function(event) {
                    params.api.stopEditing();
                    event.stopImmediatePropagation();
                    if (params.data.type === AttributeTypeEnum.JSON) {
                        showAttrModal(event,params, false, true);
                    } else {
                        showAttrModal(event,params, false, false);
                    }
                });

                return eDiv;
            }
            return `<span>${params.value}</span>`
        }
    }

    const updateRelationshipAttrCellValue = (params) => {
        if (params.newValue.toString().trim() !== params.oldValue.toString().trim()) {
            const mutationType = `Update${dataObject.boClass.boKey}Records`;
            const maxRecordsToUpdate = 1;
            const selectedRelationship = gridApiRelations.getSelectedNodes();
            const selectedRelatedInstance = gridApiRelatedRec.getSelectedNodes();
            updateRelationshipAttrValues(selectedRelationship, selectedRelatedInstance, params);

            let operation = '';
            switch (params.data.type) {
                case AttributeTypeEnum.INT:
                case AttributeTypeEnum.DECIMAL:
                    operation = `${mutationType}(qry: "id==${dataObject.instance.id}", ${selectedRelationship[0].data.relKey}: { update: {recordId : ${selectedRelatedInstance[0].data.id}, ${params.data.attrKey}:${params.newValue}}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                    break;
                case AttributeTypeEnum.JSON:
                case AttributeTypeEnum.TEXT: {
                    const value = params.newValue.replace(/"/g, '\\"').replace(/\n/g, "\\n");
                    operation = `${mutationType}(qry: "id==${dataObject.instance.id}", ${selectedRelationship[0].data.relKey}: { update: {recordId : ${selectedRelatedInstance[0].data.id}, ${params.data.attrKey}:"${value}"}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                    break;
                }
                case AttributeTypeEnum.DATE:
                case AttributeTypeEnum.TIMESTAMP:
                case AttributeTypeEnum.TIME:
                case AttributeTypeEnum.INCREMENTING:
                case AttributeTypeEnum.BOOLEAN:
                    operation = `${mutationType}(qry: "id==${dataObject.instance.id}", ${selectedRelationship[0].data.relKey}: { update: {recordId : ${selectedRelatedInstance[0].data.id}, ${params.data.attrKey}:"${params.newValue}"}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                    break;
                case AttributeTypeEnum.VALUE_LIST:
                    operation = `${mutationType}(qry: "id==${dataObject.instance.id}", ${selectedRelationship[0].data.relKey}: { update: {recordId : ${selectedRelatedInstance[0].data.id}, ${params.data.attrKey}: { replace: ${JSON.stringify(params.newValue)}} }}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                    break;
                case AttributeTypeEnum.EMAIL:
                    let val = params.newValue.split(',');
                    if (val.length > 0 && val[0] !== '') {
                        val = JSON.stringify(val)
                    } else {
                        val = JSON.stringify([]);
                    }
                    operation = `${mutationType}(qry: "id==${dataObject.instance.id}", ${selectedRelationship[0].data.relKey}: { update: {recordId : ${selectedRelatedInstance[0].data.id}, ${params.data.attrKey}:${val}}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                    break;
                default:
                    operation = `${mutationType}(qry: "id==${dataObject.instance.id}", ${selectedRelationship[0].data.relKey}: { update: {recordId : ${selectedRelatedInstance[0].data.id}, ${params.data.attrKey}:${params.newValue}}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                    break;
            }
            const query = gql.mutation({
                operation: operation,
                fields: ['recordsCount']
            })
            makeGraphQlRequest(query)
                .catch(() => {
                    params.node.data[params.column.colId] = params.oldValue;
                    params.api.refreshCells();
                    params.api.redrawRows();
                });
        }
    }

    const updateInstanceAttrCellValue = (params: any, gridType: GRID_TYPE) => {
        if (params.data.type === AttributeTypeEnum.LOOKUP) {
            if (params.data.oldValue !== params.data.value) {
                if (gridType === GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID) {
                    createMutationForRelatedRecordAttributes(params);
                } else if (gridType === GRID_TYPE.ATTRIBUTES_GRID) {
                    createMutationForMainAttributes(params);
                }
            }
        } else {
            if (params.newValue.toString().trim() !== params.oldValue.toString().trim()) {
                if (gridType === GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID) {
                    createMutationForRelatedRecordAttributes(params);
                } else if (gridType === GRID_TYPE.ATTRIBUTES_GRID) {
                    createMutationForMainAttributes(params);
                }
            }
        }
    }

    const createMutationForMainAttributes = (params) => {
        let operation = '';
        const maxRecordsToUpdate = 1;

        const mutationType = `Update${instanceRef.current.boClass.boKey}Records`;
        switch (params.data.type) {
            case AttributeTypeEnum.INT:
            case AttributeTypeEnum.DECIMAL:
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}:${params.newValue}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.JSON:
            case AttributeTypeEnum.TEXT: {
                const value = params.newValue.replace(/"/g, '\\"').replace(/\n/g, "\\n");
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}:"${value}", maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            }
            case AttributeTypeEnum.DATE:
            case AttributeTypeEnum.TIMESTAMP:
            case AttributeTypeEnum.TIME:
            case AttributeTypeEnum.INCREMENTING:
            case AttributeTypeEnum.BOOLEAN:
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}:"${params.newValue}", maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.VALUE_LIST:
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}: { replace: ${JSON.stringify(params.newValue)}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.EMAIL:
                let val = params.newValue.split(',');
                if (val.length > 0 && val[0] !== '') {
                    val = JSON.stringify(val)
                } else {
                    val = JSON.stringify([]);
                }
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}:${val}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.LOOKUP:
                const valueCopy = JSON.parse(JSON.stringify(params.data));
                delete valueCopy.value.value;
                const json = JSON.stringify(valueCopy.value);
                const unquoted = json.replace(/"([^"]+)":/g, '$1:');
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}:${unquoted}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            default:
                operation = `${mutationType}(qry: "id==${instanceRef.current.instance.id}", ${params.data.attrKey}:${params.newValue}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
        }
        const query = gql.mutation({
            operation: operation,
            fields: ['recordsCount']
        })
        makeGraphQlRequest(query)
            .catch(() => {
                params.node.data[params.column.colId] = params.oldValue;
                params.api.refreshCells();
                params.api.redrawRows();
            });
    }

    const createMutationForRelatedRecordAttributes = (params) => {
        let operation = '';
        const maxRecordsToUpdate = 1;
        const selectedRelationship = gridApiRelations.getSelectedNodes();
        const selectedRelatedInstance = gridApiRelatedRec.getSelectedNodes();
        updateRelatedInstanceAttrValues(selectedRelationship, selectedRelatedInstance, params);

        const mutationType = `Update${selectedRelationship[0].data.boKey}Records`;
        switch (params.data.type) {
            case AttributeTypeEnum.INT:
            case AttributeTypeEnum.DECIMAL:
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}:${params.newValue}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.JSON:
            case AttributeTypeEnum.TEXT: {
                const value = params.newValue.replace(/"/g, '\\"').replace(/\n/g, "\\n");
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}:"${value}", maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            }
            case AttributeTypeEnum.DATE:
            case AttributeTypeEnum.TIMESTAMP:
            case AttributeTypeEnum.TIME:
            case AttributeTypeEnum.INCREMENTING:
            case AttributeTypeEnum.BOOLEAN:
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}:"${params.newValue}", maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.VALUE_LIST:
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}: { replace: ${JSON.stringify(params.newValue)}}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.EMAIL:
                let val = params.newValue.split(',');
                if (val.length > 0 && val[0] !== '') {
                    val = JSON.stringify(val)
                } else {
                    val = JSON.stringify([]);
                }
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}:${val}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            case AttributeTypeEnum.LOOKUP:
                const valueCopy = JSON.parse(JSON.stringify(params.data));
                delete valueCopy.value.value;
                const json = JSON.stringify(valueCopy.value);
                const unquoted = json.replace(/"([^"]+)":/g, '$1:');
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}:${unquoted}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
            default:
                operation = `${mutationType}(qry: "id==${selectedRelatedInstance[0].data.id}", ${params.data.attrKey}:${params.newValue}, maxRecordsToUpdate: ${maxRecordsToUpdate})`
                break;
        }
        const query = gql.mutation({
            operation: operation,
            fields: ['recordsCount']
        })
        makeGraphQlRequest(query)
            .catch(() => {
                params.node.data[params.column.colId] = params.oldValue;
                params.api.refreshCells();
                params.api.redrawRows();
            });
    }

    const updateRelatedInstanceAttrValues = (selectedRelationship: any, selectedRelatedInstance: any, params: any) => {
        const rel = findRelationshipType(dataObject,selectedRelationship[0].data.relKey)
        if (rel) {
            const attr = findRelatedInstanceAttribute(rel,selectedRelatedInstance[0].data.id, params.data.attrKey)
            if (attr) {
                if (params.data.type === AttributeTypeEnum.LOOKUP) {
                    attr.value = params.data.value;
                } else {
                    attr.value  = params.newValue;
                }
                lazyLoadedInstance = JSON.parse(JSON.stringify(dataObject));
            }
        }
    }

    const updateRelationshipAttrValues = (selectedRelationship: any, selectedRelatedInstance: any, params: any) => {
        const rel = findRelationshipType(dataObject,selectedRelationship[0].data.relKey)
        if (rel) {
            const attr = findRelationshipAttribute(rel,selectedRelatedInstance[0].data.id, params.data.attrKey)
            if (attr) {
                attr.value  = params.newValue;
                lazyLoadedInstance = JSON.parse(JSON.stringify(dataObject));
            }
        }
    }

    const findRelatedInstanceAttribute = (relation: any, relatedInstanceId: number, attrKey: string) => {
        const relatedInstanceFound = relation.values.find(value => value.relatedInstance.id === relatedInstanceId)
        if (relatedInstanceFound) {
            return relatedInstanceFound.relatedInstance.attributes.find(item => item.attrKey === attrKey);
        }
        return null;
    }

    const findRelationshipAttribute = (relation: any, relatedInstanceId: number, attrKey: string) => {
        const relatedInstanceFound = relation.values.find(value => value.relatedInstance.id === relatedInstanceId)
        if (relatedInstanceFound) {
            return relatedInstanceFound.relAttributes.find(item => item.attrKey === attrKey);
        }
        return null;
    }

    const getAttributes = (attributes: any[]): any[] => {
        attributes = attributes.filter(item => item.attrKey.toLowerCase() !== "name");
        return attributes.map(item => {
            const column = {
                id: item.id,
                name: item.name,
                type: item.atrbType,
                attrKey: item.attrKey,
                uiSection: item.uiSection,
                attributeValues: item.attributeValues,
                lookupRelTypeId: item.lookupRelTypeId,
                lookupAttributeId: item.lookupAttributeId,
                defaultValue: item.defaultValue,
                oldValue: item.oldValue,
                newValue: item.newValue,
                required: item.isRequired
            };
            switch (column.type) {
                case AttributeTypeEnum.JSON:
                    column['value'] = item.value ? item.value : 'n/a';
                    column['oldValue'] = item.oldValue;
                    column['newValue'] = item.newValue;
                    column["cellEditorParams"] = {
                        isPopup: true,
                        maxLength: item.maxLength <= 0 ? 1000 : item.maxLength,
                        cols: '50',
                        rows: '6'
                    };
                    break;
                case AttributeTypeEnum.TEXT:
                    column['value'] = item.value ? item.value : 'n/a';
                    column['oldValue'] = item.oldValue;
                    column['newValue'] = item.newValue;
                    column["cellEditorParams"] = {
                        isPopup: true,
                        maxLength: item.maxLength <= 0 ? 250 : item.maxLength,
                        cols: '50',
                        rows: '2'
                    };
                    break;
                case AttributeTypeEnum.VALUE_LIST:
                    column['value'] = item.value ? item.value : [];
                    column['oldValue'] = item.oldValue;
                    column['newValue'] = item.newValue;
                    column["cellEditorParams"] = {
                        isPopup: true
                    };
                    break;
                case AttributeTypeEnum.EMAIL:
                    column['value'] = item.value ? item.value : [];
                    column['oldValue'] = item.oldValue;
                    column['newValue'] = item.newValue;
                    column["cellEditorParams"] = {
                        isPopup: true
                    };
                    break;
                case AttributeTypeEnum.DECIMAL:
                    let value = item.value ? item.value.toString() : '0';
                    if (value.indexOf('.') === -1 && value.indexOf(',') === -1) {
                        if (item.minDigitsRightOfDecimal !== -1) {
                            value = parseFloat(value).toFixed(item.minDigitsRightOfDecimal);
                        }
                    }
                    column['value'] = value;
                    column['oldValue'] = item.oldValue;
                    column['newValue'] = item.newValue;
                    column["cellEditorParams"] = {
                        maxDigitsLeftOfDecimal: item.maxDigitsLeftOfDecimal,
                        minDigitsRightOfDecimal: item.minDigitsRightOfDecimal
                    };
                    break;
                default:
                    column['value'] = item.value ? item.value : 'n/a';
                    column['oldValue'] = item.oldValue;
                    column['newValue'] = item.newValue;
            }
            return column
        })
    };

    const onRelatedRecordSelect = (params) => {
        params.node.setSelected(true);
        setSelectedRelatedRecordId(params.data.id);
        let rowDataInstanceAttr = [];
        let rowDataRelationAttr = [];
        let foundRelationship;

        if (selectedRelationTypeNode) {
            foundRelationship = findRelationshipType(instance, null, selectedRelationTypeNode.data.id)
        } else {
            foundRelationship = findRelationshipType(instance, null, selectedRelation)
        }

        if (foundRelationship) {
            let found = foundRelationship.values.find(attr => attr.relatedInstance.id === params.data.id);
            if (found) {
                rowDataInstanceAttr = getAttributes(found.relatedInstance.attributes)
                rowDataRelationAttr = getAttributes(found.relAttributes);
                setRowDataRelationsAttr(rowDataInstanceAttr);
                setRowDataRelationTypeAttr(rowDataRelationAttr);
                setSelectedRelatedRecordName(found.relatedInstance.name);
                gridApiRelationsAttr.refreshCells({ force: true });
                gridApiRelationTypeAttr.refreshCells({ force: true });
            }
        }
    }

    const onRelationshipSelect = (params) => {
        resetLazyLoadingProps();
        setSelectedRelationTypeNode(params)
        selectedRelationTypeNodeForLazy = params;
    }

    const getRelationshipTypeValues = () => {
        const query = _.cloneDeep(instance.query);
        Object.keys(query.page.relations).forEach(key => {
            if (key === selectedRelationTypeNode.data.relKey) {
                query.page.relations[key].limit = LIMIT;
                query.page.relations[key].offset = 0;
            } else {
                query.page.relations[key].limit = 0;
            }
        })

        getBoObjectData(instance.boTypes, instance.boClass.id, instance.instance.id, query)
    }

    const onRowDoubleClicked = (params) => {
        if (params.type === 'rowDoubleClicked') {
            let foundRelationship;

            if (selectedRelationTypeNode) {
                foundRelationship = findRelationshipType(instance, null, selectedRelationTypeNode.data.id)
            } else {
                foundRelationship = findRelationshipType(instance, null, selectedRelation)
            }

            if (foundRelationship) {
                relationObj = foundRelationship;
                const selRel = selectedRelationTypeNode ? selectedRelationTypeNode.data.relationship :
                    rowDataRelations.find(el => el.id === selectedRelation)?.relationship;
                doubleClickedRel = {
                    ...foundRelationship,
                    selectedRelationship: selRel
                };
                let found = foundRelationship.values.find(attr => attr.relatedInstance.id === params.data.id);
                if (found) {
                    const breadcrumb = _.cloneDeep(breadcrumbSteps);
                    const index = _.findIndex(breadcrumb, function(item) {
                        return item.instanceId === params.data.id
                    });
                    if (index === -1) {
                        setSelectedRelationTypeNode(null);
                        getGridData(foundRelationship.toBoClassInfo.id, params.data.id);
                    }
                }
            }
        }
    }

    const navigateToInstance = (breadcrumbStep: any) => {
        if (breadcrumbStep.instanceId !== dataObject.instance.id) {
            let breadcrumb = _.cloneDeep(breadcrumbSteps);
            const index = _.findIndex(breadcrumb, function(item) {
                return item.instanceId === breadcrumbStep.instanceId
            });

            if (index < breadcrumb.length - 1) {
                breadcrumb.splice(index + 1)
            }

            setBreadcrumbSteps(breadcrumb);
            setSelectedRelationTypeNode(null);
            resetState();
            getGridData(breadcrumbStep.boId, breadcrumbStep.instanceId)
        }
    }

    const showAttrModal = (event, params, openedWithKeyCombo, isJson) => {
        let jsonValue = {};
        if (openedWithKeyCombo) {
            setTextAreaValueHandler(event)
        } else {
            setTextAreaValueHandler(params)
        }

        if (isJson) {
            try {
                jsonValue = JSON.parse(params.value);
            } catch (e) {
                toastr.warning('The provided JSON is not valid')
            }
        }

        setAttrValue({
            value: isJson ? jsonValue : params.value.trim(),
            isJson: isJson
        });
        textAreaModalRef.current.open()
    }

    const saveTextAreaModalValue = (newTextValue: string) => {
        textAreaValueHandler.node.setDataValue(textAreaValueHandler.column.colId, newTextValue)
        let currentCell = textAreaValueHandler.api.getFocusedCell();
        let finalRowIndex = textAreaValueHandler.api.getLastDisplayedRow();

        // If we are editing the last row in the grid, don't move to next line
        if (textAreaValueHandler.column.colDef.gridType === GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID) {
            if (currentCell.rowIndex === finalRowIndex) {
                gridApiRelationTypeAttr.ensureIndexVisible(0);

                // scrolls to the current column
                let currentCol = columnApiRelationTypeAttr.getAllDisplayedColumns()[1];
                gridApiRelationTypeAttr.ensureColumnVisible(currentCol);

                // sets focus into the grid cell
                gridApiRelationTypeAttr.setFocusedCell(0, currentCol);
                let currentCell = gridApiRelationTypeAttr.getFocusedCell();

                gridApiRelationTypeAttr.startEditingCell({
                    rowIndex: currentCell.rowIndex,
                    colKey: currentCell.column.colId
                })
                return;
            }
        } else if (textAreaValueHandler.column.colDef.gridType === GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID) {
            if (currentCell.rowIndex === finalRowIndex) {
                setTimeout(() => {
                    Utils.$('#input-instance-name').focus();
                },50)
                return;
            }
        }

        // textAreaValueHandler.api.clearFocusedCell();
        textAreaValueHandler.api.setFocusedCell(currentCell.rowIndex + 1, currentCell.column);
        textAreaValueHandler.api.startEditingCell({
            rowIndex: currentCell.rowIndex + 1,
            colKey: currentCell.column.colId
        })
    }

    const attributesOnCellKeyDown = (e: any) => {
        if (e.event.ctrlKey && e.event.altKey) {
            e.api.stopEditing();
        }
        if (e.data.type === AttributeTypeEnum.TEXT || e.data.type === AttributeTypeEnum.JSON) {
            if (e.event.shiftKey && e.event.code === 'Enter') {
                e.api.stopEditing();
                if (e.data.type === AttributeTypeEnum.JSON) {
                    showAttrModal(e,e, true, true);
                } else {
                    showAttrModal(e,e, true, false);
                }
            }
        }
    }

    const cellEditingStarted = (params: any, gridType: GRID_TYPE) => {
        if (params.data.type === AttributeTypeEnum.LOOKUP) {
            params.api.stopEditing();
            params.data.oldValue = params.data.value;
            params.data.newValue = params.data.value;
            lookupInstanceModal.current.show(params.data, params.column.colDef.boTypes, gridType);
        }
    }

    const nextCellForEdit = (gridType: GRID_TYPE) => {
        let currentGridApi;
        let nextGridApi;
        let nextColumnApi;
        switch (gridType) {
            case GRID_TYPE.ATTRIBUTES_GRID:
                currentGridApi = gridApi;
                nextGridApi = gridApiRelationTypeAttr;
                nextColumnApi = columnApiRelationTypeAttr;
                break;
            case GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID:
                currentGridApi = gridApiRelationTypeAttr;
                nextGridApi = gridApiRelationsAttr;
                nextColumnApi = columnApiRelationsAttr;
                break;
            case GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID:
                currentGridApi = gridApiRelationsAttr;
                // This grid is the last one in the tab sequence so there are no nextApis
                break;
        }
        let currentCell = currentGridApi.getFocusedCell();
        let finalRowIndex = currentGridApi.getLastDisplayedRow();
        const moveToNextGrid = currentCell === null ? true : currentCell.rowIndex === finalRowIndex;

        // move to next grid
        if (moveToNextGrid) {
            if (gridType === GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID) {
                // This grid is the last one in the tab sequence so the focus is set to the name field
                setTimeout(() => {
                    Utils.$('#input-instance-name').focus();
                },50)
                return;
            }

            nextGridApi.ensureIndexVisible(0);

            // scrolls to the value column of the next grid
            let valueColumn = nextColumnApi.getAllDisplayedColumns()[1];
            nextGridApi.ensureColumnVisible(valueColumn);

            // sets focus into the grid cell
            nextGridApi.setFocusedCell(0, valueColumn);
            let valueCell = nextGridApi.getFocusedCell();

            nextGridApi.startEditingCell({
                rowIndex: valueCell.rowIndex,
                colKey: valueCell.column.colId
            })
            return;
        }

        currentGridApi.setFocusedCell(currentCell.rowIndex + 1, currentCell.column);
        currentGridApi.startEditingCell({
            rowIndex: currentCell.rowIndex + 1,
            colKey: currentCell.column.colId
        })
    };

    const onSaveLookupAttribute = (data: any, gridType: GRID_TYPE) => {
        let rowNode;
        switch (gridType) {
            case GRID_TYPE.ATTRIBUTES_GRID:
                rowNode = gridApi.getRowNode(data.id);
                break;
            case GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID:
                rowNode = gridApiRelationTypeAttr.getRowNode(data.id);
                break;
            case GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID:
                rowNode = gridApiRelationsAttr.getRowNode(data.id);
                break;
        }
        const rowData = rowNode.data;
        rowData.value = {
            id: data.instanceId,
            value: data.name
        };
        rowNode.setData(rowData);
        if (gridType === GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID) {
            updateRelationshipAttrCellValue(rowNode);
        } else {
            updateInstanceAttrCellValue(rowNode, gridType);
        }
    };

    const onBodyScroll = (event) => {
        const viewPortHeight = Utils.$('#related-records .ag-body-viewport.ag-layout-normal.ag-row-no-animation').height();
        const containerHeight = Utils.$('#related-records .ag-body-viewport.ag-layout-normal.ag-row-no-animation .ag-center-cols-clipper').height();

        if (scrollTop < event.top && viewPortHeight + event.top >= containerHeight - 5) {
            scrollTop = event.top
            if (!pending) {
                pending = true;
                const relIndex = lazyLoadedInstance.relationships.findIndex(item => item.relKey === selectedRelationTypeNodeForLazy.data.relKey);
                if (lazyLoadedInstance.relationships[relIndex].values.length === selectedRelationTypeNodeForLazy.data.numOfRelatedValues) {
                    return;
                }

                const query = _.cloneDeep(lazyLoadedInstance.query);
                Object.keys(query.page.relations).forEach(key => {
                    if (key === selectedRelationTypeNodeForLazy.data.relKey) {
                        query.page.relations[key].limit = LIMIT;
                        query.page.relations[key].offset += LIMIT;
                    } else {
                        query.page.relations[key].limit = 0;
                        query.page.relations[key].offset = 0;
                    }
                })

                relatedRecordsGridApi.showLoadingOverlay();
                getBoObjectData(lazyLoadedInstance.boTypes, lazyLoadedInstance.boClass.id, lazyLoadedInstance.instance.id, query, true)
                    .finally(() => {
                        pending = false
                        relatedRecordsGridApi.hideOverlay();
                    })
            }
        }
    }

    const headerNameListener = (e) => {
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
        if (e.keyCode === 9) {
            const inputValue = e.target.value;
            if (dataObject.instance.name !== inputValue) {
                const mutationType = `Update${instance.boClass.boKey}Records`;
                const maxRecordsToUpdate = 1;
                let operation = `${mutationType}(qry: "id==${instance.instance.id}", name:"${inputValue}", maxRecordsToUpdate: ${maxRecordsToUpdate})`;
                const query = gql.mutation({
                    operation: operation,
                    fields: ['recordsCount']
                })

                makeGraphQlRequest(query).finally(() => {
                    dataObject.instance.name = inputValue;
                    updateBreadcrumbStep(dataObject);
                })
            }
            e.preventDefault();
            // scrolls to the first row
            gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = columnApiAttr.getAllDisplayedColumns()[1];
            gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            gridApi.setFocusedCell(0, currentCol);
            let currentCell = gridApi.getFocusedCell();

            gridApi.startEditingCell({
                rowIndex: currentCell.rowIndex,
                colKey: currentCell.column.colId
            })
        }
    }

    const attributesTabToNextCell = (params) => {
        let previousCell = params.previousCellPosition,
            lastRowIndex = previousCell.rowIndex,
            nextRowIndex = params.backwards ? lastRowIndex - 1 : lastRowIndex + 1,
            renderedRowCount = attributesGridApi.getModel().getRowCount(),
            result;

        if (nextRowIndex < 0) {
            nextRowIndex = -1;
        }

        if (nextRowIndex >= renderedRowCount) {
            nextRowIndex = renderedRowCount - 1;
        }

        if (params.nextCellPosition === null) {
            setTimeout(() => {
                attributesGridApi.stopEditing();
                attributesGridApi.clearFocusedCell();

                /*First trying to set the focus to Selected relationship's attributes grid*/
                /*Then if there are no records, trying to set the focus to Selected related record's attributes grid*/
                /*Then if there are no records, set the focus back to the instance name field*/
                if (relationshipAttrGridApi.getDisplayedRowCount() === 0) {
                    if (relatedInstanceAttrGridApi.getDisplayedRowCount() === 0) {
                        setTimeout(() => {
                            Utils.$('#input-instance-name').focus();
                        }, 50)
                        return;
                    } else {
                        relatedInstanceAttrGridApi.ensureIndexVisible(0);

                        // scrolls to the current column
                        let currentCol = relatedInstanceAttrColumnApi.getAllDisplayedColumns()[1];
                        relatedInstanceAttrGridApi.ensureColumnVisible(currentCol);

                        // sets focus into the grid cell
                        relatedInstanceAttrGridApi.setFocusedCell(0, currentCol);
                        let currentCell = relatedInstanceAttrGridApi.getFocusedCell();

                        relatedInstanceAttrGridApi.startEditingCell({
                            rowIndex: currentCell.rowIndex,
                            colKey: currentCell.column.colId
                        })
                        return;
                    }
                } else {
                    relationshipAttrGridApi.ensureIndexVisible(0);

                    // scrolls to the current column
                    let currentCol = relationshipAttrColumnApi.getAllDisplayedColumns()[1];
                    relationshipAttrGridApi.ensureColumnVisible(currentCol);

                    // sets focus into the grid cell
                    relationshipAttrGridApi.setFocusedCell(0, currentCol);
                    let currentCell = relationshipAttrGridApi.getFocusedCell();

                    relationshipAttrGridApi.startEditingCell({
                        rowIndex: currentCell.rowIndex,
                        colKey: currentCell.column.colId
                    })
                    return;
                }
            }, 10)
        } else {
            result = {
                rowIndex: nextRowIndex,
                column: previousCell.column,
                floating: previousCell.floating,
            };

            return result;
        }
    }

    const relatedInstanceAttrTabToNextCell = (params) => {
        let previousCell = params.previousCellPosition,
            lastRowIndex = previousCell.rowIndex,
            nextRowIndex = params.backwards ? lastRowIndex - 1 : lastRowIndex + 1,
            renderedRowCount = relatedInstanceAttrGridApi.getModel().getRowCount(),
            result;

        if (nextRowIndex < 0) {
            nextRowIndex = -1;
        }

        if (nextRowIndex >= renderedRowCount) {
            nextRowIndex = renderedRowCount - 1;
        }

        if (params.nextCellPosition === null) {
            setTimeout(() => {
                Utils.$('#input-instance-name').focus();
            },50)
            return;
        }

        result = {
            rowIndex: nextRowIndex,
            column: previousCell.column,
            floating: previousCell.floating,
        };

        return result;
    }

    const relationshipAttrTabToNextCell = (params) => {
        let previousCell = params.previousCellPosition,
            lastRowIndex = previousCell.rowIndex,
            nextRowIndex = params.backwards ? lastRowIndex - 1 : lastRowIndex + 1,
            renderedRowCount = relationshipAttrGridApi.getModel().getRowCount(),
            result;

        if (nextRowIndex < 0) {
            nextRowIndex = -1;
        }
        if (nextRowIndex >= renderedRowCount) {
            nextRowIndex = renderedRowCount - 1;
        }

        if (params.nextCellPosition === null) {
            setTimeout(() => {
                relationshipAttrGridApi.stopEditing();
                relationshipAttrGridApi.clearFocusedCell();

                if (relatedInstanceAttrGridApi.getDisplayedRowCount() === 0) {
                    setTimeout(() => {
                        Utils.$('#input-instance-name').focus();
                    }, 50)
                    return;
                }

                relatedInstanceAttrGridApi.ensureIndexVisible(0);

                // scrolls to the current column
                let currentCol = relatedInstanceAttrColumnApi.getAllDisplayedColumns()[1];
                relatedInstanceAttrGridApi.ensureColumnVisible(currentCol);

                // sets focus into the grid cell
                relatedInstanceAttrGridApi.setFocusedCell(0, currentCol);
                let currentCell = relatedInstanceAttrGridApi.getFocusedCell();

                relatedInstanceAttrGridApi.startEditingCell({
                    rowIndex: currentCell.rowIndex,
                    colKey: currentCell.column.colId
                })
                return;
            }, 10)
        }

        result = {
            rowIndex: nextRowIndex,
            column: previousCell.column,
            floating: previousCell.floating,
        };

        return result;
    }

    const onAttrGridReady = (params) => {
        setGridApi(params.api);
        setColumnApiAttr(params.columnApi);
        attributesGridApi = params.api;
        params.api.sizeColumnsToFit();
    };

    const onRelationsGridReady = (params) => {
        setGridApiRelations(params.api);
        params.api.sizeColumnsToFit();
    };

    const onRelationsGridReadyFirstRender = (params) => {
        setGridApiRelations(params.api);
        params.api.sizeColumnsToFit();
        params.api.forEachNode(node=> node.rowIndex ? 0 : node.setSelected(true))
    };

    const onRelatedRecGridReadyFirstRender  = (params) => {
        setGridApiRelatedRec(params.api);
        params.api.sizeColumnsToFit();
        params.api.forEachNode(node => {
            if (node.rowIndex === 0) {
                node.setSelected(true);
                setSelectedRelatedRecordId(node.data.id);
            }
        });
    };

    const onRelatedRecGridReady = (params) => {
        setGridApiRelatedRec(params.api);
        params.api.sizeColumnsToFit();
    };

    const onRelsAttrGridReady = (params) => {
        setGridApiRelationsAttr(params.api);
        setColumnApiRelationsAttr(params.columnApi);
        relatedInstanceAttrGridApi = params.api;
        relatedInstanceAttrColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    };

    const onRelTypeAttrGridReady = (params) => {
        setGridApiRelationTypeAttr(params.api);
        relationshipAttrGridApi = params.api;
        setColumnApiRelationTypeAttr(params.columnApi)
        relationshipAttrColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    };

    const getInstanceName = () => {
        if (instance && instance.attributes) {
            const nameAttr = instance.attributes.filter(attr => attr.attrKey.toLowerCase() === 'name');
            if (nameAttr.length > 0 && nameAttr[0].unique) {
                return `Unique ${instance.boClass.name} Name`
            } else {
                return `${instance.boClass.name} Name`
            }
        }
        return '...';
    }


    const showTip = (e) => {
        const tipText = "By double clicking on related record's name you can access record's details";
        const tip = Utils.$('<div id="qtipDoubleClick"></div>')
            .append($(`<span style='font-size: 12px'>${tipText}</span>`));
        const helpTip = tip.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Tip:"
                },
                text: helpTip,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-navigator',
                width: 350
            }
        });
    }

    const navigateToRelatedInstance = () => {
        const params = {
            type: 'rowDoubleClicked',
            data: {
                id: selectedRelatedRecordId
            }
        }
        onRowDoubleClicked(params);
    }

    const isNavigationDisabled = () => {
        const found = breadcrumbSteps.find(step => step.instanceId === selectedRelatedRecordId);
        return !!found;
    }

    const onBackToList = () => {
        props.backToList(props.businessObject.name.toLowerCase());
    };

    return(
        <div id={"instanceLayoutEditor"} style={{width: "100%", height: "100%", backgroundColor: '#2D3436'}}>
            <LoadinModal open={loading} />
            <div style={{
                width: "100%",
                display: "flex",
                height: 70,
                paddingTop: 5,
                paddingBottom: 5,
                paddingLeft: 5,
                paddingRight: 5,
                borderBottom: "2px solid black"
            }} className={'background-gradient'}>
                <div style={{
                    height: 40,
                    width: "100%"
                }}>
                    <label style={{
                        color: "#f5f4f4",
                    }} htmlFor={'input-instance-name'}>{getInstanceName()}</label>
                    <div style={{width: '100%', display: 'flex', paddingRight: 1}}>
                        <input
                            title={instance ? instance.name : "..."}
                            key={instance ? instance.instance.name : "..."}
                            type={"text"}
                            // readOnly={true}
                            style={{fontSize: 15, marginRight: 5, marginTop: 2, height: 34, border: 'none', borderRadius:3, width: '100%'}}
                            defaultValue={instance ? instance.instance.name : "..."}
                            tabIndex={2}
                            id={'input-instance-name'}
                            className={'new-design'}
                            onKeyDown={headerNameListener}
                        />
                        <div style={{display: "flex", paddingTop: 2}}>
                            <button onClick={onBackToList} id={'back-to-list'}
                                    className={"btn btn-new-design"} title={'Back To List'}>
                                <i className="fas fa-backward"> Back To List</i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <InstanceLayoutBreadcrumb steps={breadcrumbSteps} navigateToInstance={navigateToInstance}/>
            <div id={'data-nav-grid'} className={`grids-container ${breadcrumbSteps.length > 1 ?
                'grids-container-height-breadcrumb' : 'grids-container-full-height'}`}>

                {/*Instance attributes grid - GRID_TYPE.ATTRIBUTES_GRID*/}
                <div style={{height: '97%', width: '28%',  marginLeft: '5px'}}>
                    <header className={'instance-layout-grid-header instance-name-container'}>
                        {instance ?
                            <React.Fragment>
                                <h5 title={instance.instance.name}>
                                    {instance.instance.name}
                                </h5><h5>Attributes</h5>
                            </React.Fragment> :
                            <React.Fragment>
                                <h5/><h5>Attributes</h5>
                            </React.Fragment>
                        }
                    </header>
                    <div className="ag-theme-balham-dark ag-grids"
                         style={{backgroundColor: "#353535", width: "100%", height: "100%", paddingBottom: '10px'}}
                         id="attributes">
                            <AgGridReact
                                onGridReady         = {onAttrGridReady}
                                onFirstDataRendered = {onAttrGridReady}
                                columnDefs          = {attrColumnDefs}
                                rowData             = {rowDataAttributes}
                                tabToNextCell       = {attributesTabToNextCell}
                                defaultColDef={{
                                    minWidth: 150,
                                    flex: 1,
                                }}
                                gridOptions={{
                                    resizable: true,
                                    singleClickEdit: true,
                                    getRowNodeId: data => data.id,
                                    onCellKeyDown: attributesOnCellKeyDown,
                                    onCellEditingStarted: params => cellEditingStarted(params, GRID_TYPE.ATTRIBUTES_GRID),
                                    suppressDragLeaveHidesColumns: true
                                }}
                                components={{
                                    agInstanceAttributes: getAttributesEditor()
                                }}
                            >
                            </AgGridReact>
                    </div>
                </div>

                {/*Second column container*/}
                <div style={{height: '99.4%', width: '40%', marginLeft: '5px'}}>

                    <div style={{height: '46%', display: "flex"}}>
                        {/*Instance relationships grid - GRID_TYPE.RELATIONSHIPS_GRID*/}
                        <div style={{width: '60%'}}>
                            <header className={'instance-layout-grid-header instance-name-container'}>
                                {instance ?
                                    <React.Fragment>
                                        <h5 title={instance.instance.name}>
                                            {instance.instance.name}
                                        </h5><h5>Relationships</h5>
                                    </React.Fragment> :
                                    <React.Fragment>
                                        <h5/><h5>Relationships</h5>
                                    </React.Fragment>
                                }
                            </header>
                            <div className="ag-theme-balham-dark ag-grids"
                                 style={{backgroundColor: "#353535", width: "100%", height: "100%", paddingBottom: '10px'}}
                                 id="relationships-types-grid">
                                <AgGridReact
                                    onGridReady         = {onRelationsGridReady}
                                    onFirstDataRendered = {onRelationsGridReadyFirstRender}
                                    columnDefs          = {columnDefsRelationsGrid}
                                    rowData             = {rowDataRelations}
                                    onCellClicked       = {onRelationshipSelect}
                                    defaultColDef={{
                                        flex: 1,
                                    }}
                                    gridOptions={{
                                        resizable: true,
                                        suppressDragLeaveHidesColumns: true
                                    }}
                                >
                                </AgGridReact>
                            </div>
                        </div>

                        {/*Related records grid - GRID_TYPE.RELATED_RECORDS_GRID*/}
                        <div style={{width: '40%', marginLeft: '4px'}}>
                            <header className={'instance-layout-grid-header'}>
                                <h5>Related Records</h5>
                                <div style={{
                                    paddingRight: 5,
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    <i className="fas fa-question-circle tip-btn" onClick={showTip}/>
                                </div>
                            </header>
                            <div className="ag-theme-balham-dark ag-grids"
                                 style={{backgroundColor: "#353535", width: "100%", height: "100%", paddingBottom: '10px'}}
                                 id="related-records">
                                <AgGridReact
                                    onGridReady         = {onRelatedRecGridReady}
                                    onFirstDataRendered = {onRelatedRecGridReadyFirstRender}
                                    columnDefs          = {columnDefsRelatedRecGrid}
                                    rowData             = {rowDataRelatedRec}
                                    onCellClicked       = {onRelatedRecordSelect}
                                    onRowDoubleClicked  = {onRowDoubleClicked}
                                    overlayLoadingTemplate={overlayLoadingTemplate}
                                    defaultColDef={{
                                        flex: 1,
                                    }}
                                    gridOptions={{
                                        resizable: true,
                                        getRowNodeId: function (data) {
                                            return data.id;
                                        },
                                        onBodyScroll: onBodyScroll,
                                        deltaRowDataMode: true,
                                        suppressDragLeaveHidesColumns: true
                                    }}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                    </div>

                    {/*Selected relationship's attributes grid - GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID*/}
                    <div style={{height: '46%', marginTop: '6%'}}>
                        <header className={'instance-layout-grid-header'}>
                            <h5>Selected Relationship Attributes</h5>
                        </header>
                        <div className="ag-theme-balham-dark ag-grids"
                             style={{backgroundColor: "#353535", width: "100%", height: "98%"}}
                             id="relationship-attributes">
                            <AgGridReact
                                onGridReady         = {onRelTypeAttrGridReady}
                                onFirstDataRendered = {onRelTypeAttrGridReady}
                                columnDefs          = {columnDefsRelationTypeAttrGrid}
                                rowData             = {rowDataRelationTypeAttr}
                                tabToNextCell       = {relationshipAttrTabToNextCell}
                                defaultColDef={{
                                    flex: 1,
                                }}
                                gridOptions={{
                                    resizable: true,
                                    singleClickEdit: true,
                                    getRowNodeId: function (data) {
                                        return data.id;
                                    },
                                    onCellKeyDown: attributesOnCellKeyDown,
                                    onCellEditingStarted: params => cellEditingStarted(params, GRID_TYPE.RELATIONSHIPS_ATTRIBUTES_GRID),
                                    suppressDragLeaveHidesColumns: true
                                }}
                                components={{
                                    agInstanceAttributes: getAttributesEditor()
                                }}
                            >
                            </AgGridReact>
                        </div>
                    </div>

                </div>

                {/*Selected related record's attributes grid - GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID*/}
                <div style={{width: '31%', marginLeft: '5px', marginRight: '5px',
                    border: '2px solid #3F6F75', paddingBottom: 5}}>
                    <div style={{height: '98%'}}>
                        <header style={{backgroundColor: '#3F6F75', border: '1px solid #3F6F75'}}
                                className={'instance-layout-grid-header instance-name-container narrow-name-container'}>
                            {rowDataRelatedRec.length > 0 ?
                                <React.Fragment>
                                    <h5 title={selectedRelatedRecordName}>
                                        {selectedRelatedRecordName}
                                    </h5><h5>Attributes</h5>
                                    <div style={{
                                        paddingRight: 5,
                                        display: "flex",
                                    }}>
                                        <button id={'navigateToBtn'}
                                                onClick={navigateToRelatedInstance}
                                                className={"btn btn-new-design navigate-btn"}
                                                title={isNavigationDisabled() ? "You already navigated to this record once" :
                                                    "Navigate to record's details"}
                                                disabled={isNavigationDisabled()}
                                        >
                                            <i className="fas fa-directions fa-lg"/> Navigate To
                                        </button>
                                    </div>
                                </React.Fragment> :
                                <React.Fragment>
                                    <h5/><h5>Selected Related Record Attributes</h5>
                                </React.Fragment>
                            }
                        </header>
                        <div className="ag-theme-balham-dark ag-grids"
                             style={{backgroundColor: "#353535", width: "100%", height: "98%"}}
                             id="related-records-attributes">
                            <AgGridReact
                                onGridReady={onRelsAttrGridReady}
                                onFirstDataRendered={onRelsAttrGridReady}
                                columnDefs={columnDefsRelationsAttrGrid}
                                rowData={rowDataRelationsAttr}
                                tabToNextCell={relatedInstanceAttrTabToNextCell}
                                defaultColDef={{
                                    flex: 1,
                                }}
                                gridOptions={{
                                    resizable: true,
                                    singleClickEdit: true,
                                    getRowNodeId: function (data) {
                                        return data.id;
                                    },
                                    onCellKeyDown: attributesOnCellKeyDown,
                                    onCellEditingStarted: params => cellEditingStarted(params, GRID_TYPE.RELATED_RECORD_ATTRIBUTES_GRID),
                                    suppressDragLeaveHidesColumns: true
                                }}
                                components={{
                                    agInstanceAttributes: getAttributesEditor()
                                }}
                            >
                            </AgGridReact>
                        </div>
                    </div>
                </div>

            </div>
            <EditAttrModal
                ref = {textAreaModalRef}
                attrValue={attrValue}
                fieldName={textAreaValueHandler ? textAreaValueHandler.data.name : ''}
                saveTextAreaModalValue={saveTextAreaModalValue}
            />
            <LookupInstanceModal {...{save: onSaveLookupAttribute}} nextCellForEdit={nextCellForEdit} ref={lookupInstanceModal}/>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        businessObject: state.manageDataBusinessObject.businessObject,
    }
};

export default connect(mapStateToProps, null)(InstanceLayoutEditor)



// WEBPACK FOOTER //
// ./app/components/bo-core/instanceLayoutEditor/InstanceLayoutEditor.tsx